import { IonSpinner } from "@ionic/react";
import { Auth } from "aws-amplify";
import { autorun, observable } from "mobx";
import { disposeOnUnmount, inject, observer } from "mobx-react";
import React from "react";
import { RouteComponentProps } from "react-router";
import { postData } from "../../plugins/auth/auth";
import { USER } from "../../config";

interface IProps extends RouteComponentProps {
  userStore?: any;
}

@inject("userStore")
@observer
class CallBack extends React.Component<IProps> {
  @disposeOnUnmount
  @observable
  public baseInit: any = {
    headers: {},
    response: true,
  };
  public checkUserAndRedirect = async () => {
    const currentAuthenticatedUser = await Auth.currentAuthenticatedUser();
    if (currentAuthenticatedUser) {
      window.location.href = "/goals";
    } else {
      window.location.href = "/";
    }
  };
  public googleCallbackAutorun = autorun(async () => {
    setTimeout(async () => {
      let googleIdToken;
      Object.keys(localStorage).forEach((key) => {
        if (key.endsWith("idToken")) {
          googleIdToken = localStorage.getItem(key);
        }
      });
      if (googleIdToken) {
        let init = this.baseInit;
        await postData(USER, `/user/google-callback`, {
          ...init,
          body: { googleIdToken },
        })
          .catch(async () => {
            await this.checkUserAndRedirect();
          })
          .finally(async () => {
            await this.checkUserAndRedirect();
          });
      } else {
        window.location.href = "/";
      }
    }, 3000);
  });

  render(): React.ReactNode {
    return (
      <div className="dashboard-column">
        <IonSpinner className="loading" />
      </div>
    );
  }
}

export default CallBack;
